// 团队管理数据
export const DASH_GET_TEAMUSER_LIST = 'DASH_GET_TEAMUSER_LIST'

// 设置下级返点
export const DASH_SET_FOLLWER_REBET = 'DASH_SET_FOLLWER_REBET'

// 设置下级返点
export const DASH_SET_FOLLWER_REBET_NEW = 'DASH_SET_FOLLWER_REBET_NEW';

// 获取账变记录
export const GET_ACCOUNT_CR = 'GET_ACCOUNT_CR'

// 获取彩种与玩法关系
export const GET_LOTTERY_METHOD = 'GET_LOTTERY_METHOD'

// 获取投注记录
export const GET_BET_RECORD = 'GET_BET_RECORD'

// 获取投注详情
export const GET_BET_DETAIL = 'GET_BET_DETAIL'

// 撤单
export const CANCEL_BET = 'CANCEL_BET'

// 检查用户名
export const CHECK_USERNAME = 'CHECK_USERNAME';

// 开户
export const ADD_USER = 'ADD_USER';

// 获取推广链接
export const GET_PROMOTION_LINK = 'GET_PROMOTION_LINK';

// 设置贵广链接返点
export const SET_PROMOTION_LINK = 'SET_PROMOTION_LINK';

// 获取团队统计报表信息
export const GET_TEAM_STATISTICS = 'GET_TEAM_STATISTICS';

export const GET_TEAM_STATISTICS_V2 = 'GET_TEAM_STATISTICS_V2';

export const GET_TEAM_STATISTICS_V3 = 'GET_TEAM_STATISTICS_V3';

// 获取日工资
export const GET_DAILY_WAGES = 'GET_DAILY_WAGES';

// 获取下级契约
export const GET_TEAM_CONTRACT = 'GET_TEAM_CONTRACT';

// 创建契约
export const CREATE_CONTRACT = 'CREATE_CONTRACT';

// 创建棋牌契约
export const CREATE_CONTRACT_XY = 'CREATE_CONTRACT_XY';

// 更新契约
export const UPDATE_CONTRACT = 'UPDATE_CONTRACT'

// 获取下级时薪
export const GET_TEAM_WAGE = 'GET_TEAM_WAGE'

// 获取真人反水
export const GET_CASINO_COMPACT = 'GET_CASINO_COMPACT'

// 获取体育反水
export const GET_SPORT_COMPACT = 'GET_SPORT_COMPACT'

// 获取kgame反水
export const GET_KGAME_COMPACT = 'GET_KGAME_COMPACT'

// 获取电竞反水
export const GET_ESPORTS_COMPACT = 'GET_ESPORTS_COMPACT'

// 获取棋牌反水
export const GET_CHESS_COMPACT = 'GET_CHESS_COMPACT'

// 获取真人电子体育数据
export const GET_EPROFITLOSS = 'GET_EPROFITLOSS'

// 获取新手任务
export const GET_USER_TASK = 'GET_USER_TASK'

// 获取日亏损报表
export const GET_DAILY_LOSS = 'GET_DAILY_LOSS'

// 获取月亏损报表
export const GET_MONTH_LOSS = 'GET_MONTH_LOSS'

// 获取彩票报表
export const GET_LOTTERY_REPORT = 'GET_LOTTERY_REPORT'

// 获取彩票账变
export const GET_LOTTERY_CR = 'GET_LOTTERY_CR'

// 获取追号信息
export const GET_TRACKS = 'GET_TRACKS'

// 获取追号详情
export const GET_TRACK_DETAIL = 'GET_TRACK_DETAIL'

// 停止追号
export const STOP_TRACKS = 'STOP_TRACKS'

// 修改登录密码
export const CHANGE_LOGIN_PASSWORD = 'CHANGE_LOGIN_PASSWORD';

// 获取转账信息
export const GET_TRANSFER_RECORD = 'GET_TRANSFER_RECORD'

// 验证安全问题
export const CHECK_SEC_QA = 'CHECK_SEC_QA'

// 使用TOKEN设置安全密码
export const SET_SEC_PASS = 'SET_SEC_PASS'

// 验证提款密码
export const CHECK_SEC_PASS = 'CHECK_SEC_PASS'

// 获取银行信息
export const GET_BANK_INFO = 'GET_BANK_INFO'

// 锁定银行卡
export const LOCK_BANK_CARD = 'LOCK_BANK_CARD'

// 增加银行卡
export const ADD_BANK_CARD = 'ADD_BANK_CARD'

// 重新绑定银行卡
export const REBIND_BANK_CARD = 'REBIND_BANK_CARD'

// 绑定手机号
export const BIND_PHONE_NUMBER = 'BIND_PHONE_NUMBER'

// 检查手机号
export const CHECK_PHONE_NUMBER = 'CHECK_PHONE_NUMBER'

// 获取真人电子投注信息
export const GET_BET_RECORD_FOR_CASINO = 'GET_BET_RECORD_FOR_CASINO'

// 下级转账
export const TRANSFER_TO_MEMBER = 'TRANSFER_TO_MEMBER'

// 销毁节点数据
export const DESTROY_NODE = 'DESTROY_NODE'

// 获取新手任务奖金
export const GET_GUIDE_TASK_MONEY = 'GET_GUIDE_TASK_MONEY'

// 获取彩票契约分红
export const GET_LOTTERY_CONTRACT = 'GET_LOTTERY_CONTRACT'

// 发彩票分红
export const PROVIDE_DIVIDENT = 'PROVIDE_DIVIDENT'

// 检查彩票分红
export const CHECK_DIVIDENT = 'CHECK_DIVIDENT'

// 创建彩票契约
export const CREATE_LOTTERY_CONTRACT = 'CREATE_LOTTERY_CONTRACT'

// 更新彩票契约
export const UPDATE_LOTTERY_CONTRACT = 'UPDATE_LOTTERY_CONTRACT'

// 查看彩票分红详情
export const GET_LOTTERY_CONTRACT_DETAIL = 'GET_LOTTERY_CONTRACT_DETAIL'

// 获取团队报表中不同分类数据
export const GET_TEAM_STATISTICS_BY_TYPE = 'GET_TEAM_STATISTICS_BY_TYPE'

// 获取棋牌返水
export const GET_PORKER_COMPACT = 'GET_PORKER_COMPACT'

// 获取团队报表中不同分类数据2.0
export const GET_TEAM_STATISTICS_BY_TYPE_V2 = 'GET_TEAM_STATISTICS_BY_TYPE_V2'
